/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { CollectionNestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxi-total-item',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxiTotalItemComponent extends CollectionNestedOption {
    @Input()
    get alignment(): string {
        return this._getOption('alignment');
    }
    set alignment(value: string) {
        this._setOption('alignment', value);
    }

    @Input()
    get column(): string {
        return this._getOption('column');
    }
    set column(value: string) {
        this._setOption('column', value);
    }

    @Input()
    get cssClass(): string {
        return this._getOption('cssClass');
    }
    set cssClass(value: string) {
        this._setOption('cssClass', value);
    }

    @Input()
    get customizeText(): Function {
        return this._getOption('customizeText');
    }
    set customizeText(value: Function) {
        this._setOption('customizeText', value);
    }

    @Input()
    get displayFormat(): string {
        return this._getOption('displayFormat');
    }
    set displayFormat(value: string) {
        this._setOption('displayFormat', value);
    }

    @Input()
    get name(): string {
        return this._getOption('name');
    }
    set name(value: string) {
        this._setOption('name', value);
    }

    @Input()
    get showInColumn(): string {
        return this._getOption('showInColumn');
    }
    set showInColumn(value: string) {
        this._setOption('showInColumn', value);
    }

    @Input()
    get skipEmptyValues(): boolean {
        return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value: boolean) {
        this._setOption('skipEmptyValues', value);
    }

    @Input()
    get summaryType(): string {
        return this._getOption('summaryType');
    }
    set summaryType(value: string) {
        this._setOption('summaryType', value);
    }

    @Input()
    get valueFormat(): DevExpress.ui.format | string {
        return this._getOption('valueFormat');
    }
    set valueFormat(value: DevExpress.ui.format | string) {
        this._setOption('valueFormat', value);
    }


    protected get _optionPath() {
        return 'totalItems';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxiTotalItemComponent
  ],
  exports: [
    DxiTotalItemComponent
  ],
})
export class DxiTotalItemModule { }
